import { AxiosResponse } from 'axios';
import { NewHttpResponseList } from 'shell/models/http-response';
import { ActDomainManagement } from 'shell/models/act-domain-management';
import { ActDomainManagmentResponseVM } from 'civil-status/view-models/act-domain-managment-list';

export const transformerActDomains = (
  response: AxiosResponse<NewHttpResponseList<ActDomainManagement>>
): ActDomainManagmentResponseVM => {
  const data = response.data.payload || [];
  const pageInfo = response.data?.pageInfo;

  if (pageInfo) {
    pageInfo.page = pageInfo.page / pageInfo.pageSize;
  }

  return {
    pageInfo,
    actDomains: data?.map((actDomain: ActDomainManagement) => ({
      domainType: actDomain?.key?.idDominio?.toString() || '',
      domainName: actDomain?.nomeDominio || '',
    })),
  };
};
